import log from 'loglevel'
import shortid from 'shortid'

log.setLevel('debug')

var originalFactory = log.methodFactory
log.methodFactory = function (methodName, logLevel, loggerName) {
  var rawMethod = originalFactory(methodName, logLevel, loggerName)
  return function (...args) {
    // rawMethod('Newsflash: ', ...args)
    var id = shortid.generate()
    rawMethod(`[${id}]`, ...args)
    //debugger
  }
}
log.setLevel(log.getLevel()) // Be sure to call setLevel method in order to apply plugin

export default log